import apiService from 'library/api-service';
import { createAsyncThunk } from '@reduxjs/toolkit';

const getGibTypes = createAsyncThunk('getGibTypes', async () => {
  const response = await apiService.getGibTypes();

  return { gibTypes: response.data };
});

const gibTypesActions = { getGibTypes };

export default gibTypesActions;
